var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app_tree" },
    [
      _c(
        "div",
        {
          staticStyle: {
            padding: "15px 10px",
            "font-weight": "600",
            "font-size": "15px"
          }
        },
        [
          _vm._v("\n      目录\n      "),
          _c(
            "el-popover",
            {
              attrs: {
                "popper-class": "zl_sidebar_popper",
                placement: "bottom",
                width: "100",
                trigger: "click"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "zl_sidebar_popper_btn",
                  staticStyle: { "user-select": "none" }
                },
                [
                  _c(
                    "p",
                    { staticClass: "popper_p", on: { click: _vm.addTreeItem } },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../static/images/newCourseImages/tianjia@2x.png"),
                          alt: "添加节点"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("添加节点")])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-circle-plus-outline",
                staticStyle: { float: "right", cursor: "pointer" },
                attrs: { slot: "reference" },
                slot: "reference"
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-tree", {
        ref: "tree",
        style: { height: _vm.height },
        attrs: {
          data: _vm.treeData,
          "node-key": "id",
          props: _vm.defaultProps,
          draggable: true,
          "highlight-current": true,
          "default-expanded-keys": [_vm.defaultExpansion]
        },
        on: { "node-drop": _vm.handleDrop, "node-click": _vm.handleNodeClick },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "div",
                {
                  staticClass: "custom-tree-node",
                  on: {
                    "&mouseover": function($event) {
                      return _vm.treeMouseOver($event, data)
                    },
                    "&mouseleave": function($event) {
                      return _vm.treemouseLeave()
                    },
                    dblclick: function($event) {
                      return _vm.edit(data)
                    }
                  }
                },
                [
                  data.id && data.status != 1
                    ? _c("span", { attrs: { title: data.catalogName } }, [
                        _vm._v(_vm._s(data.catalogName))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.status == 1
                    ? _c("el-input", {
                        ref: "edit" + data.id,
                        staticClass: "nodeInput",
                        staticStyle: { width: "90%", "margin-right": "20px" },
                        attrs: {
                          size: "small",
                          placeholder: "添加目录",
                          maxlength: "100"
                        },
                        on: {
                          blur: function($event) {
                            return _vm.blurEdit(data)
                          }
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.enterBlur($event, data)
                          }
                        },
                        model: {
                          value: data.catalogName,
                          callback: function($$v) {
                            _vm.$set(data, "catalogName", $$v)
                          },
                          expression: "data.catalogName"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.iconIsShow == data.id
                    ? _c(
                        "span",
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                "popper-class": "zl_sidebar_popper1",
                                placement: "bottom",
                                width: "100",
                                trigger: "click"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "zl_sidebar_popper_btn",
                                  staticStyle: { "user-select": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.edit(data)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/zh@2x.png"),
                                          alt: "编辑节点"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("编辑节点")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.remove(node, data)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/sc@2x(1).png"),
                                          alt: "删除节点"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("删除节点")])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              data.id
                                ? _c("span", {
                                    staticClass: "el-icon-more catalogedtordel",
                                    class: {
                                      "tree-node-block":
                                        _vm.iconIsShow == data.id &&
                                        data.status != 1
                                    },
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openSelectType.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    slot: "reference"
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                "popper-class": "zl_sidebar_popper",
                                placement: "bottom",
                                width: "100",
                                trigger: "click"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "zl_sidebar_popper_btn",
                                  staticStyle: { "user-select": "none" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 6)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/zh@2x.png"),
                                          alt: "混合模式"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("混合模式")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 10)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/sp@2x.png"),
                                          alt: "添加视频"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("添加视频")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 8)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/wd@2x.png"),
                                          alt: "添加文本"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("添加文本")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 5)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/ceyan@2x.png"),
                                          alt: "添加测验"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("添加测验")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 7)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/tp@2x.png"),
                                          alt: "添加图片"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("添加图片")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "popper_p",
                                      on: {
                                        click: function($event) {
                                          return _vm.append(node, data, 9)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../static/images/newCourseImages/yp@2x.png"),
                                          alt: "添加音频"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("添加音频")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  data.catalogParentId === 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "popper_p",
                                          on: {
                                            click: function($event) {
                                              return _vm.append(node, data, 0)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../static/images/newCourseImages/tianjia@2x.png"),
                                              alt: "添加节点"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("添加节点")])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              data.resourceBase && data.resourceBase.length == 0
                                ? _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    class: {
                                      "tree-node-block":
                                        _vm.iconIsShow == data.id &&
                                        data.status != 1
                                    },
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openSelectType.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    slot: "reference"
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb93cca6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb93cca6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/zl-sidebar.vue
// module id = null
// module chunks = 